import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MemberListItemResponse, MemberResponse } from '.';
import { API_BASE } from '../api-base.token';
import { PermissionResponse } from '../permissions';
import { MemberRequest } from './member-request';

const path = 'members';

@Injectable({
  providedIn: 'root',
})
export class MembersHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  get() {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.get<MemberListItemResponse[]>(url);
  }

  getName() {
    const url = Location.joinWithSlash(this.apiBase, `${path}/name`);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.httpClient.get<string>(url, { responseType: 'text' as any });
  }

  getById(id: string) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${id}`);

    return this.httpClient.get<MemberResponse>(url);
  }

  getLoggedInMember() {
    const url = Location.joinWithSlash(this.apiBase, `${path}/logged-in`);

    return this.httpClient.get<MemberResponse>(url);
  }

  getPermissions(id: string) {
    const url = Location.joinWithSlash(
      this.apiBase,
      `${path}/${id}/permissions`
    );

    return this.httpClient.get<PermissionResponse[]>(url);
  }

  post(memberRequest: MemberRequest) {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.post(url, memberRequest);
  }

  put(memberId: string, memberRequest: MemberRequest) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${memberId}`);

    return this.httpClient.put<MemberResponse>(url, memberRequest);
  }

  delete(memberId: string) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${memberId}`);

    return this.httpClient.delete<MemberResponse>(url);
  }
}
